import { http } from "../../../shared/api/http";
import { Table } from "../models/type";

export async function getTables(status:any=''): Promise<Table> {
  const url = status?`/waiter/tables?status=${status}`:`/waiter/tables`
  const res = await http.get(url);
  return res.data;
}